var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operation_instruction",style:({
    left: _vm.left + 'px'
})},[_c('span',{staticClass:"iconfont icon-cloudshellyunminglinghang operation_instruction_icon"}),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.msCmdTip))])])}
var staticRenderFns = []

export { render, staticRenderFns }